<template>
	<div class="form-group">
		<h3>Filters</h3>

		<table>
			<thead>
				<tr>
					<th>Key</th>
					<th>Value</th>
					<th>Remove</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(filter, index) in localFilters" :key="index">
					<td>
						<BaseInput v-model="filter.key" />
					</td>
					<td>
						<BaseInput v-model="filter.value" />
					</td>
					<td>
						<button @click.prevent="removeFilter(index)">
							Remove
						</button>
					</td>
				</tr>
			</tbody>
		</table>

		<p>
			<button type="button" @click.prevent="addFilter">
				Add filter
			</button>
		</p>
	</div>
</template>

<script>
import BaseInput from '@/core/components/BaseInput'

export default {
	name: 'AddCommandFormFilterList',
	components: {
		BaseInput,
	},
	props: {
		modelValue: {
			type: Array,
			required: true,
		},
	},
	emits: [
		'requestAddFilter',
		'requestRemoveFilter',
	],
	data() {
		return {
			localFilters: [...this.modelValue],
		};
	},
	watch: {
		modelValue: {
			handler(newValue) {
				this.localFilters = newValue;
			},
			deep: true,
		},
		localFilters: {
			handler(newFilters) {
				this.$emit('update:modelValue', newFilters);
			},
			deep: true,
		},
	},
	methods: {
		addFilter() {
			this.$emit('requestAddFilter');
		},
		removeFilter(index) {
			this.$emit('requestRemoveFilter', index);
		},
	},
};
</script>
